import Moment from 'moment'
import * as Redux from 'redux'
import * as App from '../../app'
import * as DetailPanel from '../../components/detail-panel'
import * as IsActive from '../../components/is_active'
import * as Modal from '../../components/modal'
import * as Sortable from '../../components/sortable'
import * as Request from '../../request'
import * as FilterGroup from '../filter-group'
import * as PostsUtils from '../posts/utils'
import * as SourceConfig from '../source-config'
import * as Actions from './actions'
import * as Constants from './constants'
import * as Types from './types'

const normalizeTypes: Sortable.TypeNormalizer<Types.Source> =
  (payload: Types.Source[]): Sortable.SortableData<Types.Source> => {
  return payload.map((s: Types.Source) => ({
    ...s,
    created_datetime: Moment(s.created),
    last_failure_datetime: s.last_failure ? Moment(s.last_failure) : null,
    last_success_datetime: s.last_success ? Moment(s.last_success) : null,
    subscription_type_sortable: PostsUtils.subscriptionTypeToNum(s.subscription_type),
    updated_datetime: Moment(s.updated),
  }))
}

const stateFlushReducer = (sourceReducer: any) =>
  (state: Types.SourcesDataState, action: Redux.Action) => {
  switch (action.type) {
    case Request.successConstant(Constants.ADD_SOURCE):
    case App.SELECT_COMMUNITY:
    case Request.successConstant(SourceConfig.UPDATE_SOURCE_SUBMIT):
      return []
    default:
      return sourceReducer(state, action)
  }
}

const reducerEvent: Sortable.ReducerEvent<Types.Source> = {
  defaultSort: {field: 'created_datetime', dir: 'desc'},
  normalizer: normalizeTypes,
  requestEvent: Constants.FETCH_SOURCES,
}

const addSourceModalReducerEvent: Modal.ReducerEvent<Types.AddSourceData> = {
  initializeState: () => Constants.emptyAddSourceModalState,
  requestEvent: Constants.ADD_SOURCE,
}

const addFilterModalReducerEvent: Modal.ReducerEvent<FilterGroup.ModalData> = {
  initializeState: () => ({name: '', tags: ''}),
  requestEvent: Constants.ADD_FILTER,
}

const importModalReducerEvent: Modal.ReducerEvent<Types.ImportSourceData> = {
  initializeState: () => Constants.emptyImportModalState,
  requestEvent: Constants.IMPORT_SOURCES,
  resetStateOnOpen: true,
}

const emptyViewState: Types.SourcesViewState = {
  filter: IsActive.FILTER_STATUS_ACTIVE,
  isLoading: false,
  sort: [],
}

const emptySourcesExportState: any = {
  isExportLoading: false,
}

export const sourcesExportReducer =
  (state: any = emptySourcesExportState, action: Actions.ExportSourcesAction) => {
  switch (action.type) {
    case Request.requestConstant(Constants.EXPORT_SOURCES):
      return {
        ...state,
        isExportLoading: true,
      }
    case Request.successConstant(Constants.EXPORT_SOURCES):
    case Request.errorConstant(Constants.EXPORT_SOURCES):
      return {
        ...state,
        isExportLoading: false,
      }
    default:
      return state
  }
}

export const reducer = Redux.combineReducers({
  data: IsActive.chainedReducer(
    stateFlushReducer(Sortable.stateReducer(reducerEvent)), Constants.UPDATE_SOURCE_INLINE),
  detailPanel: DetailPanel.createReducer(Constants.PAGE_PREFIX),
  export: sourcesExportReducer,
  modalAddFilters: Modal.reducer(addFilterModalReducerEvent),
  modalAddSource: Modal.reducer(addSourceModalReducerEvent),
  modalImport: Modal.reducer(importModalReducerEvent),
  view: IsActive.filterReducer(
    Sortable.viewReducer(reducerEvent), Constants.FETCH_SOURCES, emptyViewState),
})



// WEBPACK FOOTER //
// ./src/pages/sources/reducer.ts